fx.ns("desktop.calendar", class CalendarView extends shared.stage.BaseView {

    constructor(board) {
        super(board);

        this.vmargin = 100;
        this.spaceAfterPage = fx.get("app") == "config" ? 25 : 100;
        this.spaceBeforePages = fx.get("app") == "config" ? 25 : 100;
        this.spaceAfterCover = 100;
    }

    update(animate) {
        super.update(animate);

        let screenWidth = (this.board.realWidth-125); // 125 == topbar | TODO : get TopBar reference
        let screenHeight = (this.board.realHeight); 
        let screenWidthMax = screenWidth;
        let screenHeightMax = screenHeight;
        
        let childs = this.board.allChilds;

        let yPos = this.vmargin;
        let childScale;

        if (this.board.calendarCreation.isSinglePage)
        {
            let nextLine = false;
            let lastXPos = "";
            for (let i = 0; i < childs.length; i++) 
            {
                let child = childs[i];

                if (child instanceof shared.stage.Area) {

                    childScale = screenHeightMax / child.height() / 1.4;
                    
                    child.show();

                    let xPos;

                    if (!child.data.isCover && screenWidth / (child.realWidth * childScale) > 2.2)
                    {
                        let margin = (screenWidth - child.realWidth * childScale*2) / 3
                        if (!lastXPos || lastXPos == "right")
                        {
                            xPos = margin/ childScale;
                            lastXPos = "left";
                        }
                        
                        else
                        {
                            xPos = (2*margin + child.realWidth * childScale)/ childScale;
                            lastXPos = "right";
                            nextLine = true;
                        }
                    }
                    else
                    {
                        xPos = (screenWidth - child.realWidth * childScale) / 2 / childScale;
                        nextLine = true;
                    }

                    this.applyPosition(child, {
                        scale: childScale,
                        x: xPos,
                        y: (/*(i == 0)? yPos - childs[0].realHeight * childScale :*/ yPos) / childScale
                    }, animate);

                    if (nextLine)
                    {
                        yPos += child.realHeight * childScale + (child.data.isCover ? this.spaceAfterCover : this.spaceAfterPage);
                        nextLine = false;
                    }
                        

                    /*if (i == 0)
                        yPos -= childs[0].realHeight * childScale;*/

                }
                else 
                {
                    child.show();

                    //yPos += childs[0].realHeight * childScale ;

                    this.applyPosition(child, {
                        scale: 1,
                        x: (screenWidth - child.realWidth) / 2,
                        y: yPos
                    }, animate);

                    yPos += child.realHeight + this.spaceBeforePages;
                }
            }
        }
        else
        {
            for (let i = 0; i < childs.length; i++) 
            {
                let child = childs[i];

                if (child instanceof shared.stage.Area) {

                    childScale = screenWidthMax / child.width() / 2;
                    
                    child.show();

                    this.applyPosition(child, {
                        scale: childScale,
                        x: (screenWidth - child.realWidth * childScale) / 2 / childScale,
                        y: ((i == 0)? yPos - childs[0].realHeight * childScale : yPos) / childScale
                    }, animate);

                    yPos += child.realHeight * childScale + (child.data.isCover ? this.spaceAfterCover : this.spaceAfterPage);

                }
                else 
                {
                    child.show();

                    this.applyPosition(child, {
                        scale: 1,
                        x: (screenWidth - child.realWidth) / 2,
                        y: yPos
                    }, animate);

                    yPos += child.realHeight + this.spaceBeforePages;
                }
            }
        }
        

        this.delay(this.scroll, animate ? 250 : 0);
    }

    select(area, animate) {
        if (!this.enabled) return;

        let position = this.getPosition(area);
        if (position) {
            let yPos = (position.y * position.scale) - (this.board.realHeight - area.realHeight * position.scale) / 2;
            this.board.scrollableContent.scroll(yPos, animate, "vertical");
        }
    }

    scroll(all) {
        let offset = this.board.realHeight;

        this._areasVisible = [];
        this._areasNotVisible = [];

        let viewPort = { top: this.board.scrollableContent.scrollPosition - offset, bottom: this.board.scrollableContent.scrollPosition + this.board.scrollableContent.realHeight + offset };
        
        let childs = this.board.allChilds;


        for (let i = 0; i < childs.length; i++) {
            let area = childs[i];

            if (!(area instanceof shared.stage.Area)) continue;

            if (!area.initialized)
                continue;

            let position = fx.graphics.getTranslate(area, false);

            let visible = (position.y + area.realHeight * area.scale >= viewPort.top && position.y + area.realHeight * area.scale <= viewPort.bottom)
                || (position.y >= viewPort.top && position.y <= viewPort.bottom)

            this._addAreaVisible(area, visible);

            if (visible) {
                let areaCenter = (position.y + (area.realHeight * area.scale / 2)) - this.board.scrollableContent.scrollPosition;
                let surfaceCenter = this.board.scrollableContent.realHeight / 2;
                area._distanceToCenter = Math.abs(surfaceCenter - areaCenter, area.id);
            }

        }

        this.delay(this._loadUnLoadAreas, 10);
        
        let areasSorted = this._areasVisible.sort(function (a, b) { return (a._distanceToCenter - b._distanceToCenter); });
        let activeArea1 = areasSorted[0];
        let activeArea2 = areasSorted[1];

        if (activeArea1 && activeArea2 && activeArea1._distanceToCenter == activeArea2._distanceToCenter)
            return [activeArea1, activeArea2]
        else
            return [activeArea1];

    }

    _loadUnLoadAreas() {
        for (let i = 0; i < this._areasNotVisible.length; i++)
            this._areasNotVisible[i].unload();

        for (let i = 0; i < this._areasVisible.length; i++)
            this._areasVisible[i].load();
    }

    _addAreaVisible(area, visible) {
        if (area instanceof shared.stage.Area) {
            if (visible) {
                this._areasVisible.add(area, true)
                this._areasNotVisible.remove(area);
            }
            else
                if (!visible) {
                    this._areasVisible.remove(area)
                    this._areasNotVisible.add(area, true);
                }
        }
    }
});
